import React from 'react';
import { Mail, Star, Heart, Coffee, ShieldCheck } from 'lucide-react';

export default function Contact() {
  return (
    <div className="bg-[#24574E] min-h-screen text-[#F5F3EE] pt-32 pb-24 px-6 overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[120%] h-[50rem] bg-radial from-[#5BC0AF]/10 via-[#5BC0AF]/5 to-transparent opacity-50 pointer-events-none" />

      <div className="max-w-3xl mx-auto relative z-10">

        {/* Header Section */}
        <div className="text-center mb-16">
          <p className="text-[#5BC0AF] font-bold text-xs uppercase tracking-[0.3em] mb-4">L'histoire du projet</p>
          <h1 className="text-4xl md:text-6xl font-black mb-8 leading-tight">
            L'outil que j'aurais aimé <br />
            <span className="italic text-[#5BC0AF]">avoir dès le début.</span>
          </h1>
        </div>

        {/* Content Section */}
        <div className="relative p-8 md:p-12 rounded-[3rem] border border-white/10 bg-white/[0.03] backdrop-blur-sm shadow-2xl">
          {/* Subtle Glow */}
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#5BC0AF]/10 blur-[80px] pointer-events-none" />

          <div className="space-y-8 text-lg md:text-xl text-[#F5F3EE]/80 font-medium leading-relaxed">
            <div className="flex items-center gap-4 mb-8">
              <div className="relative w-20 h-20 shrink-0">
                <div className="absolute -inset-1 bg-gradient-to-tr from-[#5BC0AF] to-[#F9D965] rounded-full blur-sm opacity-50" />
                <img
                  src="/images/sandro.webp"
                  alt="Sandro"
                  className="relative w-full h-full rounded-full object-cover border-2 border-white/20 shadow-lg grayscale-[30%] hover:grayscale-0 transition-all duration-500"
                />
              </div>
              <div>
                <p className="text-sm font-black uppercase tracking-widest text-white">Sandro</p>
                <p className="text-xs font-bold text-[#F9D965] opacity-80 uppercase tracking-tighter">Président d'asso depuis 5 ans</p>
              </div>
            </div>

            <p>
              Salut, moi c'est <span className="text-white font-bold">Sandro</span>. Passionné d'associatif, je suis président d'asso depuis 5 ans.
            </p>
            <p>
              Comme vous, j'ai vécu les fichiers Excel sans fin, les comptes-rendus qui s'oublient dans les limbes des boîtes mails et cette fameuse <span className="text-[#F9D965] italic">charge mentale</span> qui pèse sur toute l'équipe.
            </p>
            <hr className="border-white/5 w-12 mx-auto" />
            <p>
              J'ai créé <span className="text-[#5BC0AF] font-black uppercase">Superasso</span> <span className="text-[10px] font-bold tracking-widest uppercase border border-[#5BC0AF]/20 rounded text-[#5BC0AF]/40 px-1 ml-1 relative -top-1">Beta</span> parce que je voulais un outil qui nous comprenne vraiment.
            </p>
            <p className="border-l-2 border-[#5BC0AF]/30 pl-6 italic">
              Aujourd'hui, je vous partage mon outil idéal : une plateforme pensée pour <span className="text-white font-bold">automatiser un maximum ces tâches qu'on oublie</span> trop souvent, et nous donner les moyens de <span className="text-white font-bold">faire rayonner nos associations</span>.
            </p>
          </div>

          {/* Contact Action */}
          <div className="mt-12 pt-12 border-t border-white/5 flex flex-col items-center">
            <a
              href="mailto:contact@superasso.fr"
              className="group flex flex-col items-center gap-4 transition-all w-full max-w-sm text-center"
            >
              <div className="w-16 h-16 rounded-2xl bg-[#5BC0AF]/10 border border-[#5BC0AF]/20 flex items-center justify-center group-hover:scale-110 transition-transform">
                <Mail className="text-[#5BC0AF]" size={28} />
              </div>
              <div>
                <p className="text-sm font-black uppercase tracking-widest text-white">Une question ?</p>
                <p className="text-sm font-bold text-[#5BC0AF]">contact@superasso.fr</p>
              </div>
            </a>


          </div>
        </div>

      </div>
    </div>
  );
}
